import { render, staticRenderFns } from "./AddCustomCourse.vue?vue&type=template&id=7aa40b71&scoped=true&"
import script from "./AddCustomCourse.vue?vue&type=script&lang=js&"
export * from "./AddCustomCourse.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomCourse.vue?vue&type=style&index=0&id=7aa40b71&prod&lang=scss&scoped=true&"
import style1 from "./AddCustomCourse.vue?vue&type=style&index=1&id=7aa40b71&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa40b71",
  null
  
)

export default component.exports